import { PrivatePages } from './Pages';

export const SideMenuList = [
  { ...PrivatePages.Inicio },
  { ...PrivatePages.TurnoPrevio },
  { ...PrivatePages.Orden },
  { ...PrivatePages.Autorizaciones },
  { ...PrivatePages.Receta },
  { ...PrivatePages.Prescripcion },
  { ...PrivatePages.GrupoFamiliar },
  { ...PrivatePages.Prestadores },
  { ...PrivatePages.Reintegros },
  { ...PrivatePages.Aportes },
  { ...PrivatePages.Delegaciones },
  { ...PrivatePages.ConsumoPrestacional },
  // { ...PrivatePages.Reclamo },
];

export const SideMenuListCapitado = [{ ...PrivatePages.CuponPagoCapita }];

export const SideMenuListNoCapitado = [{ ...PrivatePages.Derivaciones }];

export const BottomMenuListAyuda = [{ ...PrivatePages.Ayuda }];

export const BottomMenuList = [{ ...PrivatePages.SignOut }];

export const TopMenuList = [
  { ...PrivatePages.Perfil },
  { ...PrivatePages.CambiarPin },
  { ...PrivatePages.TerminosCondiciones },
  { ...PrivatePages.SignOut },
];

export const UserMenuListMobile = [{ ...PrivatePages.Perfil }, { ...PrivatePages.CambiarPin }];

export const AyudaMenuListMobile = [
  { ...PrivatePages.TerminosCondiciones },
  { ...PrivatePages.Ayuda },
];
